module.exports = __webpack_public_path__ + "static/media/warning.3f308fcb.svg";